import { object, string } from 'yup'

export const validationPassword = (t) =>
  object({
    password: string()
      .test(
        'length',
        t('login.error.password_length'),
        (value) => value.length > 7
      )
      .required(t('login.error.required')),
    passwordConfirmation: string()
      .test(
        'equals',
        t('login.error.password_equals'),
        (value, current) => value === current.parent.password
      )
      .required(t('login.error.required')),
  })

export const validationEmail = (t) =>
  object({
    email: string()
      .email(t('login.error.email_format'))
      .required(t('login.error.required'))
      .transform((value) => value?.toLowerCase().trim()),
  })
